module.exports = __webpack_public_path__ + "img/new-food-fries.cce6538c.png";